import { render } from "./DiscoverMyData.vue?vue&type=template&id=1a81c17c&scoped=true"
import script from "./DiscoverMyData.vue?vue&type=script&lang=js"
export * from "./DiscoverMyData.vue?vue&type=script&lang=js"

import "./DiscoverMyData.vue?vue&type=style&index=0&id=1a81c17c&lang=scss&scoped=true"
import "./DiscoverMyData.vue?vue&type=style&index=1&id=1a81c17c&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a81c17c"]])

export default __exports__